import EnquiryForm from './components/enquiry-form';
import EnquiryTracking from './components/enquiry-tracking';
import DistanceCalculator from './components/distance-calculator';
import { initPopover, initTooltip } from '../../../Shared/Assets/utils';
import Cookies from 'js-cookie';

(function($) {
    $(function() {
        if (Cookies) {
            Cookies.remove("cmp.ret.enq.EnquiryDetails");
            Cookies.remove("EnquiryDetails");
            Cookies.remove("RememberEnquiryDetails");
            Cookies.remove("csnFinanceSettingsAu");
        }

        $("form[enquiry-form]").each(function() {
            new EnquiryForm().init(this);
        });

        $("form[distance-calculator]").each(function() {
            new DistanceCalculator().init(this);
        });

        let enquiryTracking = new EnquiryTracking();
        enquiryTracking.init();

        initTooltip();
        initPopover();

        $("[csn-control-toggle]").click(function() {
            let $this = $(this);
            let showElement = $($this.data("show"));
            let hideElement = $($this.data("hide"));
            hideElement.hide();
            showElement.fadeIn();
        });

        $("[data-toggle='collapse'].has-toggle-arrow").click(function() {
            let $this = $(this);
            if ($this.hasClass("collapsed")) {
                let expandedText = $this.data("expanded-text");
                if (expandedText !== "") {
                    $this.text($this.data("expanded-text"));
                }
            } else {
                let collapsedText = $this.data("collapsed-text");
                if (collapsedText !== "") {
                    $this.text($this.data("collapsed-text"));
                }

            }
        });

    });
})(jQuery)
